import { render, staticRenderFns } from "./BottomControl.vue?vue&type=template&id=30388edc&scoped=true&lang=pug&"
var script = {}
import style0 from "./BottomControl.vue?vue&type=style&index=0&id=30388edc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30388edc",
  null
  
)

component.options.__file = "BottomControl.vue"
export default component.exports